import React, { useEffect, useState } from 'react';
import SubCategoryAccordion from './SubCategoryAccordion';
import { getMedicalQuestionsList } from '../../../api/medicalQuestions';
import { useDispatch, useSelector } from 'react-redux';
import { setQuestionsList } from '../../../store/medicalQuestionsSlice';
import { RootState } from '../../../store/store';
import Loader from '../../BaseComponents/Loader';
import './HealthSummary.scss';

const HealthSummaryTab = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<any | null>(null);
  const [expandedAccordion, setExpandedAccordion] = useState<string | null>(
    null
  );

  const { questionsList } = useSelector((state: RootState) => state.questions);
  const { memberData } = useSelector((state: RootState) => state.member);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        if (memberData?.user_id) {
          const questions = await getMedicalQuestionsList(memberData?.user_id);
          dispatch(setQuestionsList(questions.data));
        }
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchQuestions();
  }, [dispatch, memberData?.user_id]);

  const toggleAccordion = (categoryName: string) => {
    setExpandedAccordion((prev) =>
      prev === categoryName ? null : categoryName
    );
  };

  if (isLoading) return <Loader />;
  if (error) return <div>Error loading medical questions...</div>;

  return (
    <div className='health-summary-container'>
      <form className='accordions-form'>
        <SubCategoryAccordion
          categoryName='History'
          categoryQuestionsData={questionsList['History']}
          isExpanded={expandedAccordion === 'History'}
          toggleAccordion={() => toggleAccordion('History')}
        />
        <SubCategoryAccordion
          categoryName='MOCA'
          categoryQuestionsData={questionsList['MOCA']}
          isExpanded={expandedAccordion === 'MOCA'}
          toggleAccordion={() => toggleAccordion('MOCA')}
        />
        <SubCategoryAccordion
          categoryName='PHQ-9'
          categoryQuestionsData={questionsList['PHQ-9']}
          isExpanded={expandedAccordion === 'PHQ-9'}
          toggleAccordion={() => toggleAccordion('PHQ-9')}
        />
        <SubCategoryAccordion
          categoryName='Physical Examination'
          categoryQuestionsData={questionsList['Physical Examination']}
          isExpanded={expandedAccordion === 'Physical Examination'}
          toggleAccordion={() => toggleAccordion('Physical Examination')}
        />
      </form>
    </div>
  );
};

export default HealthSummaryTab;
